import type { AuthTokens, DataResponse } from '@pms/shared';
import { api } from '@/lib/api';
import { tokenStorage } from '@/lib/token-storage';

interface LoginResponse {
  user: { id: string; email: string; first_name: string | null; last_name: string | null };
  accessToken: string;
  refreshToken: string;
}

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const res = await api.post<DataResponse<LoginResponse>>('/auth/login', { email, password });
    tokenStorage.setTokens(res.data.data.accessToken, res.data.data.refreshToken);
    return res.data.data;
  },

  async logout(): Promise<void> {
    const refreshToken = tokenStorage.getRefreshToken();
    if (refreshToken) {
      try {
        await api.post('/auth/logout', { refreshToken });
      } catch {
        // Ignore errors on logout
      }
    }
    tokenStorage.clear();
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.post('/auth/change-password', { currentPassword, newPassword });
  },

  async refresh(refreshToken: string): Promise<AuthTokens> {
    const res = await api.post<DataResponse<AuthTokens>>('/auth/refresh', { refreshToken });
    return res.data.data;
  },
};
